<template>
  <section :class="{ saving: isSaving }" v-if="ready && doc && doc.data">
    <div class="container text-center">
      <h3 class="" v-html="cms.asHtml(doc.data.viewpoints_respondent_question)"></h3>
      <div>
        <button class="btn btn-lg btn-primary" @click="submitChoice(true)" :disabled="isSaving">
          Yes
        </button>
        &nbsp;
        <button class="btn btn-lg btn-primary" @click="submitChoice(false)" :disabled="isSaving">
          No
        </button>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, onMounted, Ref, ref, watchEffect } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
import cmsService from "../../services/cms/cms";
import {
  CmsCustomStrengthMapping,
  CmsDocumentTypes,
} from "../../services/cms/cms-type-definitions";
import CmsService from "../../services/cms/cms-service";
import { StrengthsMappingModel } from "./strengths-mapping.vue";

// @Component
// export default class StrengthsMappingPreCheck extends Vue {
const props = defineProps<{ model: StrengthsMappingModel }>();

// @Prop()
//   private model!: StrengthsMappingModel;

const cms: CmsService = cmsService;
const doc: Ref<CmsCustomStrengthMapping | null> = ref(null);
const ready = ref(false);
const isSaving = ref(false);

const begin = () => {
  ready.value = true;
};

const route = useRoute();

const uid: string | undefined = route?.params?.uid as string;
const type: string | undefined = route?.meta?.type as string;

let docPromise: Promise<CmsCustomStrengthMapping> | null = null;

if (uid && type === CmsDocumentTypes.CmsCustomStrengthMapping) {
  docPromise = cms.getByUid(CmsDocumentTypes.CmsCustomStrengthMapping, uid);
} else if (props.model.CmsCustomStrengthMappingId) {
  docPromise = cms.getById(
    CmsDocumentTypes.CmsCustomStrengthMapping,
    props.model.CmsCustomStrengthMappingId,
  );
} else {
  window.location.href = `/Review/MappingStrengths/${props.model.Id}`;
}

if (docPromise) {
  docPromise.then((document) => {
    doc.value = document;
    const questionText = cms.asText(doc.value?.data?.viewpoints_respondent_question);
    if (questionText) {
      begin();
    } else {
      window.location.href = `/Review/MappingStrengths/${props.model.Id}`;
    }
  });
}

function submitChoice(choice: boolean): Promise<void> {
  if (!props.model?.Id) return Promise.reject(new Error("No model/ID supplied"));

  isSaving.value = true;
  return axios
    .post(`/Review/PreCheck/${props.model.Id}`, {
      customStrengthMappingId: props.model.CmsCustomStrengthMappingId,
      customStrengthMappingAnswer: choice,
    })
    .then((e) => {
      window.location.href = `/Review/MappingStrengths/${props.model.Id}`;
    })
    .catch((e) => {
      window.location.reload();
      isSaving.value = false;
    });
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
section {
  margin: 100px 0;
}
</style>
